module.exports = __webpack_public_path__ + "img/accessori.7cf22bb4.svg";